export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return "";

  try {
    const cleaned = phoneNumber.replace(/\D/g, "");
    const match = cleaned.match(/^(?<areaCode>\d{3})(?<prefix>\d{3})(?<lineNumber>\d{4})$/);

    if (match && match.groups) {
      const { areaCode, prefix, lineNumber } = match.groups;
      return `(${areaCode}) ${prefix}-${lineNumber}`;
    }

    return phoneNumber; // Return original if not a 10-digit number
  } catch (error) {
    console.error("Error formatting phone number:", error);
    return phoneNumber; // Return original on error
  }
};

export const formatCurrency = (amount?: number | string, currency: string = "USD") => {
  if (amount === null || amount === undefined) return "";

  try {
    const numericAmount = typeof amount === "string" ? parseFloat(amount) : amount;

    if (isNaN(numericAmount)) {
      console.warn("Invalid currency amount:", amount);
      return amount.toString(); // Return original if not a valid number
    }

    return new Intl.NumberFormat(undefined, {
      maximumSignificantDigits: 6,
      style: "currency",
      currency: currency,
    }).format(numericAmount);
  } catch (error) {
    console.error("Error formatting currency:", error);
    return amount.toString(); // Return original on error
  }
};

export const camelCase = (str: string) => {
  return str.replace(/[-_]+/g, ' ').replace(/(?:^\w|[A-Z]|\b\w)/g, (char, index) => {
    return index === 0 ? char.toLowerCase() : char.toUpperCase();
  }).replace(/[\s+]+/g, "");
};

export const slugify = (str: string) => {
  return str.toLowerCase().replace(/ /g, "-");
};

export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  } catch (error) {
    console.error(`Error formatting date "${dateString}":`, error);
    return dateString;
  }
};